/* ============================================================
   En Friendly Reminder — landing page behaviours
   Vanilla reimplementation of the Claude Design interactive
   script (buy-format selector, book page-flip, mobile sticky
   buy-bar, smooth-scroll CTAs, add-to-cart). Window-scoped
   (the design canvas frame is gone on the real page).
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmtDKK(kr) {
    // whole-krone Danish formatting: "1.299 kr"
    return Math.round(kr).toLocaleString('da-DK') + ' kr';
  }

  /* ---------- Buy-format selector ------------------------------------ */
  function initBuy(root) {
    var groups = root.querySelectorAll('[data-efr-buy]');
    groups.forEach(function (group) {
      var opts = Array.prototype.slice.call(group.querySelectorAll('[data-efr-opt]'));
      if (!opts.length) return;

      function select(opt) {
        opts.forEach(function (o) {
          var on = o === opt;
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
          o.classList.toggle('is-selected', on);
        });
        var price = parseFloat(opt.getAttribute('data-price')) || 0;
        var label = opt.getAttribute('data-label') || '';
        var delivery = opt.getAttribute('data-delivery') || '';
        var variantId = opt.getAttribute('data-variant-id') || '';
        var scope = group.getAttribute('data-efr-buy');
        var box = root.querySelector('[data-efr-summary="' + scope + '"]') || root;

        var totalEl = box.querySelector('[data-efr-total]');
        if (totalEl) totalEl.textContent = fmtDKK(price);
        var labelEl = box.querySelector('[data-efr-sellabel]');
        if (labelEl) labelEl.textContent = label;
        var delEl = box.querySelector('[data-efr-delivery]');
        if (delEl) delEl.textContent = delivery;
        var ctaEl = box.querySelector('[data-efr-cta]');
        if (ctaEl) {
          var t = ctaEl.querySelector('span') || ctaEl;
          t.textContent = 'Køb bogen - ' + fmtDKK(price);
        }
        var vInput = box.querySelector('[data-efr-variant-input]');
        if (vInput) vInput.value = variantId;
        group.setAttribute('data-selected-variant', variantId);
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          select(opt);
        });
      });
      var initial = group.querySelector('[data-efr-opt].is-selected') || opts[1] || opts[0];
      select(initial);
    });
  }

  /* ---------- Book page-flip ----------------------------------------- */
  function initBook(root) {
    var books = root.querySelectorAll('[data-efr-book]');
    books.forEach(function (book) {
      var leaves = Array.prototype.slice.call(book.querySelectorAll('[data-efr-leaf]'));
      // Turn order follows the visual stack (top leaf first), NOT DOM order:
      // the markup lists leafB before leafA, but leafA sits on top (higher
      // wrapper z-index) and must turn first. Sort by initial wrapper z desc.
      leaves.sort(function (a, b) {
        return (parseInt(b.parentNode.style.zIndex, 10) || 0) - (parseInt(a.parentNode.style.zIndex, 10) || 0);
      });
      var fwd = book.querySelector('[data-efr-page="fwd"]');
      var fwdProxies = Array.prototype.slice.call(book.querySelectorAll('[data-efr-page="fwd-proxy"]'));
      var back = book.querySelector('[data-efr-page="back"]');
      // page label may sit just outside the card; walk up a few ancestors.
      var label = null, scope = book;
      for (var k = 0; k < 4 && scope; k++) {
        label = scope.querySelector('[data-efr-pages]');
        if (label) break;
        scope = scope.parentElement;
      }
      var mode = book.getAttribute('data-efr-book'); // 'desktop' | 'mobile'
      var max = leaves.length;
      var turns = 0, turning = -1, timer = null;

      function render() {
        leaves.forEach(function (leaf, i) {
          var turned = turns > i;
          // Set the resting transform inline (NOT via an !important class):
          // an !important class would override the Web-Animation on a forward
          // turn and kill the flip; an inline value lets the animation play
          // during its run and settle to this afterwards. Works both ways.
          leaf.style.transform = turned ? 'rotateY(-180deg)' : 'rotateY(0deg)';
          var wrap = leaf.parentNode;
          // turning leaf rides above everything during its flip
          wrap.style.zIndex = (i === turning) ? 40 : (turned ? (11 + i) : (20 - i));
        });
        if (fwd) { fwd.style.opacity = turns < max ? '1' : '0'; fwd.style.pointerEvents = turns < max ? 'auto' : 'none'; }
        if (back) { back.style.opacity = turns > 0 ? '1' : '0'; back.style.pointerEvents = turns > 0 ? 'auto' : 'none'; }
        if (label) {
          if (mode === 'mobile') {
            label.textContent = turns === max ? '… og 50 sider mere' : 'Side ' + (3 + turns) + ' af 55';
          } else {
            label.textContent = 'Side ' + (2 + turns * 2) + '-' + (3 + turns * 2) + ' af 55';
          }
        }
      }

      function flip(leaf, forward) {
        if (REDUCED || !leaf.animate) return;
        var from = forward ? 'rotateY(0deg)' : 'rotateY(-180deg)';
        var to = forward ? 'rotateY(-180deg)' : 'rotateY(0deg)';
        leaf.animate([{ transform: from }, { transform: to }],
          { duration: 950, easing: 'cubic-bezier(0.4, 0.06, 0.25, 1)' });
      }

      function settle() { turning = -1; render(); }
      function goFwd(e) {
        if (e) e.preventDefault();
        if (turns >= max) return;
        turning = turns;
        flip(leaves[turning], true);
        turns++; render();
        clearTimeout(timer); timer = setTimeout(settle, 950);
      }
      function goBack(e) {
        if (e) e.preventDefault();
        if (turns <= 0) return;
        turning = turns - 1;
        flip(leaves[turning], false);
        turns--; render();
        clearTimeout(timer); timer = setTimeout(settle, 950);
      }
      if (fwd) fwd.addEventListener('click', goFwd);
      fwdProxies.forEach(function (p) { p.addEventListener('click', goFwd); });
      if (back) back.addEventListener('click', goBack);
      render();
    });
  }

  /* ---------- Mobile sticky buy-bar ---------------------------------- */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-efr-stickybar]');
    if (!bar) return;
    var anchor = root.querySelector('[data-efr-hero-end]');
    function onScroll() {
      var threshold = anchor ? (anchor.getBoundingClientRect().bottom < 0) : (window.scrollY > 430);
      bar.classList.toggle('is-visible', threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Smooth-scroll CTAs ------------------------------------- */
  function initJumps(root) {
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-efr="jump-buy"],[data-efr="jump-story"]');
      if (!t) return;
      e.preventDefault();
      var sel = t.getAttribute('data-efr') === 'jump-story' ? '[data-efr-anchor="story"]' : '[data-efr-anchor="buy"]';
      var layout = t.closest('.efr-layout') || root;
      var dest = layout.querySelector(sel) || root.querySelector(sel);
      if (!dest) return;
      var y = dest.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Add to cart ------------------------------------------- */
  function initCart(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-efr="add-to-cart"]');
      if (!btn) return;
      var layout = btn.closest('.efr-layout') || root;
      var group = btn.closest('[data-efr-summary]') || layout;
      var vInput = group.querySelector('[data-efr-variant-input]') ||
                   layout.querySelector('[data-efr-variant-input]');
      var variantId = vInput && vInput.value;
      if (!variantId) {
        // no variant mapped yet — fall back to the product page if configured
        var purl = root.getAttribute('data-efr-product-url');
        if (purl) { e.preventDefault(); window.location.href = purl; }
        return;
      }
      e.preventDefault();
      btn.setAttribute('aria-busy', 'true');

      // Graft the theme's own add-to-cart flow: POST to /cart/add.js asking for
      // the cart-drawer section HTML, then hand the response to the drawer's
      // renderContents() — which re-renders the drawer AND opens it (Dawn/Thor).
      var drawer = document.querySelector('cart-drawer');
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      var payload = { id: parseInt(variantId, 10), quantity: 1 };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.removeAttribute('aria-busy');
        if (res && res.status) { window.location.href = rootUrl + 'cart'; return; } // sold out / error
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);              // re-renders the drawer + opens it
          // On the FIRST add (empty -> 1 item) renderContents swaps the inner
          // HTML but leaves `is-empty` on the <cart-drawer> element, and the
          // theme hides the item list while that class is set — so the drawer
          // opens blank. We just added an item, so clear the empty state.
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('#CartDrawer');
          if (inner) inner.classList.remove('is-empty');
        } else if (openCartDrawer()) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          window.location.href = rootUrl + 'cart';
        }
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = rootUrl + 'cart';
      });
    });
  }

  function initOpenCart(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-efr="open-cart"]');
      if (!btn) return;
      e.preventDefault();
      if (!openCartDrawer()) window.location.href = '/cart';
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (err) {}
    }
    return false;
  }

  /* ---------- One-shot scroll reveals (perf: replaces view() scrubbing) ----
     IntersectionObserver is unreliable when observing SVG geometry (<path>) —
     it works in desktop Chromium but frequently NOT in mobile WebKit, which is
     why the timeline line never drew on phones. So we observe a plain HTML
     ancestor as a proxy and reveal the real element (path or div) when it
     scrolls in. A rect-sweep on scroll/resize backs it up on any flaky engine. */
  function initReveals(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-efr-reveal], [data-efr-draw]'));
    if (!els.length) return;
    function reveal(el) { el.classList.add('is-inview'); }
    if (REDUCED || !('IntersectionObserver' in window)) { els.forEach(reveal); return; }

    // map each proxy (HTML) element -> the real elements to reveal
    var proxies = [], groups = [];
    els.forEach(function (el) {
      var proxy = el;
      if (el.ownerSVGElement || (el.tagName && el.tagName.toLowerCase() === 'svg')) {
        var svg = el.ownerSVGElement || el;
        proxy = svg.parentElement || svg;
      }
      var idx = proxies.indexOf(proxy);
      if (idx === -1) { proxies.push(proxy); groups.push([el]); }
      else { groups[idx].push(el); }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var idx = proxies.indexOf(en.target);
        if (idx > -1) groups[idx].forEach(reveal);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    proxies.forEach(function (p) { io.observe(p); });

    // belt-and-suspenders rect sweep (idempotent with IO; not disabled by it)
    var done = false, ticking = false;
    function sweep() {
      if (done) return;
      var vh = window.innerHeight || document.documentElement.clientHeight, remaining = false;
      for (var i = 0; i < proxies.length; i++) {
        if (!groups[i].length) continue;
        var r = proxies[i].getBoundingClientRect();
        if ((r.width || r.height) && r.top < vh * 0.95 && r.bottom > 0) {
          groups[i].forEach(reveal); io.unobserve(proxies[i]); groups[i] = [];
        } else { remaining = true; }
      }
      if (!remaining) { done = true; window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; sweep(); }); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    sweep();
  }

  /* ---------- Story video: click-to-load facade (perf) ---------------- */
  function initVideo(root) {
    root.querySelectorAll('[data-efr-video-play]').forEach(function (btn) {
      var tpl = btn.parentNode.querySelector('template[data-efr-video-embed]');
      if (!tpl) return;
      var warmed = false;
      btn.addEventListener('pointerenter', function () {
        if (warmed) return; warmed = true;
        var ifr = tpl.content.querySelector('iframe');
        if (!ifr) return; // native video = Shopify CDN, already connected
        var src = ifr.getAttribute('src') || '';
        var hosts = src.indexOf('vimeo') > -1
          ? ['https://player.vimeo.com', 'https://i.vimeocdn.com', 'https://f.vimeocdn.com']
          : ['https://www.youtube-nocookie.com', 'https://i.ytimg.com', 'https://www.google.com'];
        hosts.forEach(function (h) {
          var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; l.crossOrigin = '';
          document.head.appendChild(l);
        });
      });
      btn.addEventListener('click', function () {
        var parent = btn.parentNode;
        var frag = tpl.content.cloneNode(true);
        btn.remove();
        parent.appendChild(frag);
        var media = parent.querySelector('.efr-videoel');
        if (media && media.tagName === 'VIDEO') { try { media.play(); } catch (e) {} }
      });
    });
  }

  /* ---------- Autoplay-muted story video: smart prebuffer ----------------
     A native <video> streams in byte-range chunks (like YouTube buffering) —
     it never downloads the whole file up front. We keep preload="metadata"
     so the page load stays light, then start buffering ~a screen BEFORE the
     video enters view (so there's no wait when the visitor arrives) and pause
     it once scrolled well past (saving data + battery). Reduced-motion users
     get the poster + controls instead of autoplay. */
  function initVideoAutoplay(root) {
    root.querySelectorAll('video[data-efr-video-auto]').forEach(function (video) {
      video.muted = true;            // belt-and-braces for autoplay policies
      video.setAttribute('muted', '');
      if (REDUCED) { video.removeAttribute('autoplay'); return; }
      if (!('IntersectionObserver' in window)) {
        var p0 = video.play(); if (p0 && p0.catch) p0.catch(function () {});
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (video.preload !== 'auto') { try { video.preload = 'auto'; } catch (e) {} }
            var p = video.play(); if (p && p.catch) p.catch(function () {});
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, { rootMargin: '400px 0px 400px 0px', threshold: 0.15 });
      io.observe(video);
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-efr-root]');
    roots.forEach(function (root) {
      root.classList.add('efr-js');
      initBuy(root);
      initBook(root);
      initStickyBar(root);
      initJumps(root);
      initCart(root);
      initOpenCart(root);
      initReveals(root);
      initVideo(root);
      initVideoAutoplay(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();